import Vue from 'vue'
import AddTag from '@/components/component/Reuse/AddTag/AddTag.vue'
import {isEmpty, cloneDeep,sortBy, concat} from 'lodash'
import constants from '@/libs/constant/constants'
import {getImageUrl, onError, message, logout, errorHandler, loader, getCatalogId, socialShare, checkZero, getMetaFieldsToShare} from '@/libs/helper'
import {getSyncedTwitterAccount, socialShareTwitter, getFacebookAccounts, getPagesAndGroups, socialShareFacebook, synchroniseAccounts} from '@/libs/api/api'
import contextMenu from 'vue-context-menu'


export default {
    name: 'ShareMessage',
    components: {AddTag, contextMenu},
    beforeMount() {
        if (this.shareType === constants.PLATFORMS.FACEBOOK) {
            this.getFacebookAccounts()
            this.module = constants.ACCOUNT_TYPE.FACEBOOK.key
        } else if (this.shareType === constants.PLATFORMS.TWITTER) {
            this.getTwitterAccounts()
            this.module = this.shareType
        }
    },
    mounted() {
        this.scheduleTime = new Date()
        this.inputAdded()
    },
    props: {
        isShare: {
            type: Boolean,
            default: false
        },
        selectedArticle: {
            type: Object,
            default: () => {}
        },
        closeDialog: {
            type: Function,
            default: () => {}
        },
        shareType: {
            type: String,
            default: constants.PLATFORMS.TWITTER
        },
        changeUpdateArticleShareCount: {
            type: Function,
            default: () => {}
        }
    },
    computed: {
        characterCount () {
            let length = this.message.length
            if (this.selectedArticle && this.selectedArticle.url) {
              length += this.selectedArticle.url.length
            }
            return length
        },
    },
    data() {
        return {
            isEmpty,
            onError,
            getImageUrl,
            module: constants.ACCOUNT_TYPE.TWITTER.key,
            platform: 'Facebook',
            showSchedule: false,
            scheduleTime: '',
            accounts: [],
            facebookPages: [],
            facebookGroups: [],
            accountId: '',  
            templateName: '',
            isError: false,
            isPreview: false,
            accountSelected: {},
            selectedOption: '',
            selectedTwitterOption: '',
            pageToShare: '',
            template: 'Facebook Std',
            selectedFacebookOption: {},
            articleUrl: 'url',
            message: '',
            articleMessage: '',
            messageToDisplay: '',
            sync: false,
            isTagAdded: false,
            facebookOptionDropdown: false,
            platFormOptions: [{
                label: 'Facebook',
                value: 'facebook',
                icon: 'nova-facebook'
            }, {
                label: 'Twitter',
                value: 'twitter',
                icon: 'nova-twitter-icon'
            }],
            facebookOptions: [
                {
                label: 'Pages',
                id: 1,
                options: [{
                    label: 'No Pages Available',
                    value: 'NO_PAGE',
                    disabled: true
                }]
                }, {
                id: 2,
                label: 'Groups',
                options: [{
                    label: 'No Groups Available',
                    value: 'NO_GROUP',
                    disabled: true
                }]
                },
                {
                label: 'Other options',
                options: [
                    {
                    label: constants.TWITTER_OPTIONS.OTHERS.label,
                    value: constants.TWITTER_OPTIONS.OTHERS.value
                    }
                ]
                }
            ],
            twitterOptions: [
                {
                label: constants.TWITTER_OPTIONS.SHARE_TO_TIMELINE,
                options: [{
                    label: constants.TWITTER_OPTIONS.TIMELINE.label,
                    value: constants.TWITTER_OPTIONS.TIMELINE.value
                }]
                },
                {
                label: 'Other options',
                options: [{
                    label: constants.TWITTER_OPTIONS.OTHERS.label,
                    value: constants.TWITTER_OPTIONS.OTHERS.value
                }]
                }
            ],
            pickerOptions: {
                disabledDate (time) {
                return time.getTime() < Date.now() - 8.64e7
                }
            },
            menuItems:[
                {
                    text: 'Add tag'
                }]  
        }
    },
    methods: {
        onImageError (e) {
            e.target.src = require('@/assets/images/No_Image_Available.png')
        },

        changePlatform (platform) {
            this.platform = platform
        },

        changePage (command) {
            this.pageToShare = command
        },

        getSelectedMessage () {
            let message = localStorage.getItem('messageToShare')
            if (message !== null && message !== undefined && message.trim() !== '') {
                var text = document.createTextNode(message.trim())
                this.$refs.editor.appendChild(text)
                this.inputAdded()
            }
        },
    
        /**
         * get particular icon based on platform
         * @param {*} type
         */
        getIcon (type) {
            switch (type) {
                case constants.ACCOUNT_TYPE.FACEBOOK.key:
                return 'nova-facebook platform-icon'
                case constants.ACCOUNT_TYPE.TWITTER.key:
                return 'nova-twitter-icon platform-icon'
            }
        },
        
        changeTemplate (command) {
        this.template = command
        },
        
        selectArticleUrl (url) {
        this.articleUrl = url
        },

        inputAdded (e) {
            if (e) e.preventDefault()
            let message = document.getElementById('test').innerText
            let newMessage = this.getArticleValue(message)
            this.message = newMessage
            let articleMessage = document.getElementById('article-message').innerText
            articleMessage = this.getArticleValue(articleMessage)
            this.articleMessage = articleMessage
            this.messageToDisplay = `${newMessage.trim()}\n \n ${articleMessage.trim()}`
        },
        insertNewNode (isTrue) {
            var ComponentClass = Vue.extend(AddTag)
            var instance = new ComponentClass({
                propsData: { selectedFilter: '' }
            })
            instance.$mount() // pass nothing
            let editableDiv;
            if (isTrue) editableDiv = document.getElementById('article-message')
            else editableDiv = document.getElementById('test')
            editableDiv.focus()
            var range = document.createRange()
            var sel = window.getSelection()
            if (sel && sel.rangeCount > 0) {
                range = sel.getRangeAt(0)
                // check that we are in content editable div
                range.insertNode(instance.$el)
                range.setStartAfter(instance.$el)
                sel.removeAllRanges()
                sel.addRange(range)
                editableDiv.focus()
                let span = document.createElement('span')
                span.className = 'message-text'
                span.style.lineHeight = '24px'
                span.contentEditable = true
                editableDiv.appendChild(span)
            }
        },

        insertNewEditableSpan (refName) {
            let span = document.createElement('span')
            span.className = 'message-text'
            span.style.lineHeight = '24px'
            span.contentEditable = true
            this.$refs[refName].appendChild(span)
            },

        changeTagAdded (value) {
            this.isTagAdded = value
        },
        /**
         * get article value
         * @param {*} message 
         * @param {*} toShareDirect 
         */
        getArticleValue (message, toShareDirect) {
            let resultMessage = ''
            const select = /Select/g
            const title = /Title/g
            const subtitle = /Subtitle/g
            const description = /Description/g
            const pubDate = /Publication Date\(Year\)/g
            const pubDateDay = /Publication Date\(Day\)/g
            const pubDateMonth = /Publication Date\(Month\)/g
            const keywords = /Keywords/g
            const authors = /Author/g
            const publication = /Publication/g
            const publisher = /Publisher/g
            const spaceComma = / ,/g
            resultMessage = message.replace(title, getMetaFieldsToShare('TITLE', this.selectedArticle))
            resultMessage = resultMessage.replace(select, '')
            resultMessage = resultMessage.replace(subtitle, getMetaFieldsToShare('SUBTITLE', this.selectedArticle) === undefined ? '' : getMetaFieldsToShare('SUBTITLE', this.selectedArticle))
            resultMessage = resultMessage.replace(description, getMetaFieldsToShare('DESCRIPTION', this.selectedArticle))
            resultMessage = resultMessage.replace(pubDate, this.getDate(getMetaFieldsToShare('PUB_DATE', this.selectedArticle)))
            resultMessage = resultMessage.replace(pubDateDay, this.getDate(getMetaFieldsToShare('PUB_DATE', this.selectedArticle), 'DAY'))
            resultMessage = resultMessage.replace(pubDateMonth, this.getDate(getMetaFieldsToShare('PUB_DATE', this.selectedArticle), 'MONTH'))
            resultMessage = resultMessage.replace(keywords, getMetaFieldsToShare('KEYWORD', this.selectedArticle, toShareDirect))
            resultMessage = resultMessage.replace(authors, getMetaFieldsToShare('AUTHORS', this.selectedArticle, toShareDirect))
            resultMessage = resultMessage.replace(publication, getMetaFieldsToShare('PUBLICATION', this.selectedArticle, toShareDirect))
            resultMessage = resultMessage.replace(publisher, getMetaFieldsToShare('PUBLISHER', this.selectedArticle, toShareDirect))
            resultMessage = resultMessage.replace(spaceComma, ',')
            return resultMessage
        },
        /**
         * to get the article message
         * @param {*} e 
         */
        getArticleMessage (e) {
            if (e) e.preventDefault()
            let message = this.$refs.articleEditor.innerText.trim()
            let newMessage = this.getArticleValue(message)
            this.articleMessage = newMessage.trim()
        },
    
        /**
         * get Date
         * @param {*} date
         */
        getDate (date, type) {
            if (date !== undefined) {
                let d = new Date(date)
                let dateToReturn = d.getFullYear()
                if (type === 'MONTH') dateToReturn = d.getDate()
                else if (type === 'DAY') dateToReturn = d.getMonth()
                return dateToReturn
            }
        },
    
        /**
         * share button
         * @param {*} account type fb/twitter
         */
        shareButton (account) {
            if (account.type === constants.ACCOUNT_TYPE.TWITTER.key) {
                if (this.selectedOption === constants.TWITTER_OPTIONS.OTHERS.value) this.shareTwitterDialog()
                else this.shareTwitterMessageToBackend(this.getMessageToShare())
            } else if (account.type === constants.ACCOUNT_TYPE.FACEBOOK.key) {
                if (this.selectedOption === constants.TWITTER_OPTIONS.OTHERS.value) this.shareFacebookDialog()
                else this.shareFacebookMessageToBackend(this.getMessageToShare())
            }
        },
    
        /**
         * sharemessage on twitter
         */
        shareTwitterMessageToBackend (textToShare) {
            loader(this, true)
            let body = {
                message: textToShare,
                frequency: 'one_time',
                twitter_id: this.accountSelected.id,
                catalog_id: getCatalogId(),
                post_time: this.getPostDate(),
                name: `${this.getTodayDate()} - ${this.accountSelected.type}`,
                share_option: this.selectedOption.toLowerCase(),
                content_id: this.selectedArticle.id || this.selectedArticle._id,
                html: this.getHTMLToShare(),
                shared_on: this.getSharedValue(this.module),
                from_newsroom: true
            }
            socialShareTwitter(body).then(() => {
                message(this, constants.messageType.SUCCESS, 'Successfully shared')
                this.changeUpdateArticleShareCount(this.selectedArticle)
                this.closeDialog()
                loader(this, false)
            }).catch(error => {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                loader(this, false)
            })
        },
        getTodayDate () {
            let today = new Date()
            return `${checkZero(today.getDate())}-${checkZero(today.getMonth() + 1)}-${checkZero(today.getFullYear())} ${checkZero(today.getHours())}:${checkZero(today.getMinutes())}`
        },
        /**
         * share message on twitter directly(with Dialog)
         */
        shareTwitterDialog () {
            let message = this.getUserCreatedMessage()
            socialShare({platform: constants.ACCOUNT_TYPE.TWITTER.key}, this.selectedArticle, message)
            this.shareTwitterMessageToBackend(this.getMessageToShare())
        },
    
        /**
         * get Message created by user.
         */
        getMessageToShare () {
            let message = this.messageToDisplay
            if (this.selectedArticle && this.selectedArticle.url) message = `${message} \n \n ${this.selectedArticle.url}`
            return message
        },
    
        getHTMLToShare () {
            let html = ``
            if (this.message && this.message !== '') html = `<div><p>${this.message}</p></div>`
            if (this.articleMessage && this.articleMessage !== '') html = `${html} <div><p>${this.articleMessage}</p></div>`
            if (this.selectedArticle && this.selectedArticle.url) html = `${html} <div><p>${this.selectedArticle.url}</p></div>`
            return html
        },
    
        /**
         * get Message created by user.
         */
        getUserCreatedMessage () {
            let shareText = ''
            let message = this.$refs.editor.innerText.trim()
            message = this.getArticleValue(message, true)
            if (message !== '' && message !== undefined && message.trim() !== '') {
                shareText += `%0D%0A ${message}`
            }
            return shareText
        },
    
        /**
         * 
         * @param {*} ref 
         */
        getScheduledMessage (ref) {
            let newNode = this.$refs[ref].cloneNode(true)
            let element = document.body.appendChild(newNode)
            let message = element.innerText.trim()
            document.body.removeChild(element)
            return message
        },
    
        /**
         * to get the accounts of user registered in ACCURA
         */
        getUserSocialAccounts: async function () {
            try {
                // loader(this,true)
                let twitterAccounts = await getSyncedTwitterAccount()
                twitterAccounts = this.wrapTwitter(twitterAccounts)
                let facebookAccounts = await getFacebookAccounts()
                facebookAccounts = this.wrapFacebook(facebookAccounts)
                let accounts = concat(facebookAccounts, twitterAccounts)
                this.accounts = this.getAllAcounts(accounts)
                // loader(this, false)
            } catch (error) {
                console.error(error)
                // loader(this, false)
            }
        },

        /**
         * 
         * @param {*} twitterAccounts 
         */
        wrapTwitter (twitterAccounts) {
            if (isEmpty(twitterAccounts)) return []
            twitterAccounts.map(twitter => {
                twitter._id = twitter.id
                twitter.name = twitter.twitter_profile_name || ''
                return twitter
            })
            let results = sortBy(twitterAccounts, 'name')
            return results
        },

        /**
         * 
         * @param {*} fbAccounts 
         */
        wrapFacebook (fbAccounts) {
            if (isEmpty(fbAccounts)) return []
            fbAccounts.map(fb => {
                fb.name = fb.first_name + ' ' + fb.last_name
                return fb
            })
            let results = sortBy(fbAccounts, 'name')
            return results
        },

        /**
         * to get filtered/sorted social accounts
         * @param {*} accounts
         */
        getAllAcounts (accounts) {
            if (isEmpty(accounts)) {
                return [{name: 'No Accounts Added'}]
            }
            return accounts
        },
    
        /**
         * when account is selected by user
         */
        changeSelectedAccount (id) {
            if (id === 'ADD_ACCOUNT') {
                window.open(`${process.env.VUE_APP_WEB_BASE_URL}/ap/security?action=add`)
                return
            }
            let accounts = cloneDeep(this.accounts)
            this.selectedOption = ''
            this.selectedTwitterOption = ''
            this.selectedFacebookOption = {}
            accounts.filter(account => {
                if (account._id === id) this.accountSelected = account
            })
            if (this.accountSelected && this.accountSelected.type && this.accountSelected.type === constants.ACCOUNT_TYPE.FACEBOOK.key) this.createFacebookOptions()
        },
    
        /**
         * sharing menu disabled(conditions)
         */
        disabledShareButton () {
            if (isEmpty(this.accountSelected) || this.selectedOption === '' || this.message === '') return true
            // if (this.selectedOption === '') return true
            if (this.accountSelected && this.accountSelected.type && this.accountSelected.type === constants.ACCOUNT_TYPE.TWITTER.key && this.characterCount > 280) return true
            return false
        },
        /**
         * to get the posting date
         */
        getPostDate () {
            var now = new Date()
            now.setMinutes(now.getMinutes() + 1)
            now = new Date(now)
            let timeToShare = now
            if (this.scheduleTime !== '' && (new Date(this.scheduleTime) > new Date())) {
                timeToShare = this.scheduleTime
            }
            timeToShare.setSeconds(30)
            return `${timeToShare}`
        },

        /**
         * to get fb accounts
         */
        getFacebookAccounts: async function () {
            try {
                // loader(this, true)
                await this.getFacebookRecords()
                let facebookAccounts = await getFacebookAccounts()
                facebookAccounts = this.wrapFacebook(facebookAccounts)
                this.accounts = cloneDeep(facebookAccounts)
                // loader(this, false)
            } catch (error) {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                // loader(this, false)
            }
        },
        getTwitterAccounts: async function () {
            try {
                // loader(this, true)
                let accounts = await getSyncedTwitterAccount()
                let twitterAccounts = this.wrapTwitter(accounts.twitter_accounts)
                this.accounts = cloneDeep(twitterAccounts)
                // loader(this, false)
            } catch (error) {
                console.error(error)
                // loader(this, false)
            }
        },
        getFacebookRecords: async function () {
            try {
                let facebookData = await getPagesAndGroups()
                this.facebookPages = cloneDeep(facebookData.pages || [])
                this.facebookGroups = cloneDeep(facebookData.groups || [])
            } catch (error) {
                console.error('error', error)
            }
        },
    
        /**
         * to create the pages & groups for
         * facebook based on selected account
         */
        createFacebookOptions () {
        // to select the pages
        let pages = this.facebookPages.filter(page => {
            if (page.facebook_app_id === this.accountSelected.facebook_app_id) return page
        })
        // to select the groups
        let groups = this.facebookGroups.filter(group => {
            if (group.facebook_app_id === this.accountSelected.facebook_app_id) return group
        })
        // map to create the resultant options(array)
        this.facebookOptions.map(options => {
            if (options.id === 1) {
                if (!isEmpty(pages)) options.options = sortBy(pages, 'name')
                else {
                options.options = [{
                    label: 'No Pages Available',
                    value: 'NO_PAGE',
                    disabled: true
                }]
                }
            }
            if (options.id === 2) {
                if (!isEmpty(groups)) options.options = sortBy(groups, 'name')
                else {
                options.options = [{
                    label: 'No Groups Available',
                    value: 'NO_GROUP',
                    disabled: true
                }]
                }
            }
        })
        },

        /**
         * to check if facebook app is installed in group
         * @param {*} option
         */
        checkforFacebookGroup (option) {
            // to check if app is installed on facebook group
            if (option && option.group_id && !option.hasOwnProperty('app_installed_group')) {
                // if it is admin of group
                if (option.is_admin) window.open(`https://www.facebook.com/groups/${option.group_id}/apps/store`, '_blank')
                // if member
                else window.open(`https://www.facebook.com/groups/${option.group_id}/members`, '_blank')
                // to hide the popup
                this.facebookOptionDropdown = false
                this.selectedFacebookOption = {}
                this.selectedOption = ''
                return
            }
            // method for the selections
            this.selectOptionToShare(option._id || option.value)
        },

        /**
         * get fb selected option on which it will be shared
         * @param {*} option
         */
        selectOptionToShare (option) {
            // to hide the popup
            this.facebookOptionDropdown = false
            // assign value
            this.selectedOption = option
            // if other option is selected
            if (option === constants.TWITTER_OPTIONS.OTHERS.value) {
                this.selectedFacebookOption = {type: option, label: constants.TWITTER_OPTIONS.OTHERS.label}
                return
            }
            // if page is selected
            this.facebookPages.map(page => {
                if (page._id === option) {
                page.type = 'PAGE'
                this.selectedFacebookOption = cloneDeep(page)
                }
            })
            // if group is selected
            this.facebookGroups.map(group => {
                if (group._id === option) {
                group.type = 'GROUP'
                this.selectedFacebookOption = cloneDeep(group)
                }
            })
        },
    
        /**
         * api to hit to fb
         * @param {} message
         */
        shareFacebookMessageToBackend: async function (messageToShare) {
            loader(this, true)
            let option = ''
            if (this.selectedOption === constants.TWITTER_OPTIONS.OTHERS.value) {
                option = 'other'
            } else if (this.selectedFacebookOption.type === 'PAGE') {
                option = 'page'
            } else if (this.selectedFacebookOption.type === 'GROUP') {
                option = 'group'
                // if option selected is group
                let facebookData = await getPagesAndGroups()
                let groups = facebookData.groups || []
                // find the selected group from the new result
                let group = find((groups), {group_id: this.selectedFacebookOption.group_id})
                // if app is not installed show error message
                if (!isEmpty(group) && !group.hasOwnProperty('app_installed_group')) {
                message(this, constants.messageType.ERROR, 'app_not_installed')
                loader(this, false)
                return
                }
            }
            let body = {
                message: messageToShare,
                catalog_id: getCatalogId(),
                id: this.accountSelected._id,
                frequency: 'one_time',
                post_time: this.getPostDate(),
                name: `${this.getTodayDate()} - ${this.accountSelected.type}`,
                share_option: option,
                page_id: this.selectedFacebookOption.page_id,
                group_id: this.selectedFacebookOption.group_id,
                content_id: this.selectedArticle.id || this.selectedArticle._id,
                html: this.getHTMLToShare(),
                shared_on: this.getSharedValue(this.module),
                from_newsroom: true
            }
            socialShareFacebook(body).then(() => {
                message(this, constants.messageType.SUCCESS, 'Successfully shared')
                this.changeUpdateArticleShareCount(this.selectedArticle)
                this.closeDialog()
                loader(this, false)
            }).catch(error => {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                loader(this, false)
            })
        },
    
        /**
         * share on fb dialog
         */
        shareFacebookDialog () {
            let message = this.getUserCreatedMessage()
            socialShare({platform: constants.ACCOUNT_TYPE.FACEBOOK.key}, this.selectedArticle, message)
            this.shareFacebookMessageToBackend(this.getMessageToShare())
        },
        /**
         * get shared value to shared on api
         */
        getSharedValue (module) {
            if (this.selectedOption === constants.TWITTER_OPTIONS.OTHERS.value) return `others`
            switch (module) {
                case constants.ACCOUNT_TYPE.TWITTER.key:
                return `timeline: @${this.accountSelected.twitter_user_name}`
                case constants.ACCOUNT_TYPE.FACEBOOK.key:
                return `${this.selectedFacebookOption && this.selectedFacebookOption.type && this.selectedFacebookOption.type.toLowerCase()}: ${this.selectedFacebookOption.name}`
            }
        },
        /**
         * to copy the message in the preview
         */
        copyButton () {
            let message = this.$refs.preview.innerText.trim()
            if (this.showSchedule) message = this.getScheduledMessage('preview')
            navigator.clipboard.writeText(message)
        },
        /**
         * to sync the fb accounts
         * @param {*} label label
         */
        syncAccount () {
            loader(this, true)
            this.sync = true
            // body for api
            let body = {
                facebook_mongo_id: this.accountSelected._id
            }
            // api call
            synchroniseAccounts(body).then(response => {
                // to update the total pages
                this.facebookPages = cloneDeep(response.pages || [])
                // to update the total groups
                this.facebookGroups = cloneDeep(response.groups || [])
                this.createFacebookOptions()
                this.sync = false
                loader(this, false)
            }).catch(error => {
                this.sync = false
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                loader(this, false)
            })
        },
        /**
         * method to fetch preview
         * @param {*} isTrue 
         */
        async fetchPreview (isTrue) {
            if (!isTrue) {
                await this.inputAdded()
                this.isPreview = !this.isPreview
            } else {
                this.isPreview=!this.isPreview
            }
            
        },
        /**
         * to open the context menu
         */
        openMenu () {
            this.$refs.ctxMenu.open()
        },
        openArticleMenu () {
            this.$refs.articleMenu.open()
        },
        /**
         * insert the new node
         */
        insert () {
            document.getElementById('test').focus();
            this.insertNewNode()
            return false;
        },
        /**
         * insert the new node
         */
        insertInArticleMessage () {
            document.getElementById('article-message').focus();
            this.insertNewNode(true)
            return false;
        },
    }
}